
export class GoogleAnalytics {
  googleAnalytics: ReturnType<typeof useScriptGoogleAnalytics>;
  route: ReturnType<typeof useRoute>;
  id: string;

  constructor() {
    const { $config } = useNuxtApp();
    this.route = useRoute();
    this.id = $config.public.googleAnalyticsId;
    this.googleAnalytics = useScriptGoogleAnalytics({ id: this.id });

    this.googleAnalytics.onLoaded(() => {
      this.disableSendPage();
    });
  }

  disableSendPage() {
    // @ts-expect-error gtag issue in nuxt scripts, ignore
    this.googleAnalytics.proxy.gtag('config', this.id, { send_page_view: false });
  }

  page(pageName: string, properties: Record<string, any> = {}) {
    this.disableSendPage();

    // @ts-expect-error gtag issue in nuxt scripts, ignore for now
    this.googleAnalytics.proxy.gtag('event', 'page_view', {
      page_name: pageName,
      page_title: document.title,
      page_location: this.route.fullPath,
      ...properties,
    });
  }
}
